/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileQueryResponse, GetUsersProfile400 } from "../entities/GetUsersProfile";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUsersProfile } from "../api/getUsersProfile";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUsersProfileQueryKey = () => [{ url: '/users/profile' }] as const

export type GetUsersProfileQueryKey = ReturnType<typeof getUsersProfileQueryKey>

export function getUsersProfileQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getUsersProfileQueryKey()
  return queryOptions<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, GetUsersProfileQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsersProfile(config)
   },
  })
}

/**
 * @description Получение профиля
 * @summary Получение профиля
 * {@link /users/profile}
 */
export function useGetUsersProfile<TData = GetUsersProfileQueryResponse, TQueryData = GetUsersProfileQueryResponse, TQueryKey extends QueryKey = GetUsersProfileQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getUsersProfileQueryKey()

  const query = useQuery({
   ...getUsersProfileQueryOptions(config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersProfile400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}